
import MainScript from '../main.js'
//
import DesktopSidebar from './../../DesktopViews/Sidebar.vue'
import DesktopHeader from './../../DesktopViews/Header.vue'
//
import ItemsList from './../../Components/ItemsManagement/index.vue';
export default {
    name: 'DHome',
    mixins: [MainScript],
    data () {
        return {
           
           
        }
    },
  
    components: {
        'desktop-sidebar': DesktopSidebar,
        'desktop-header': DesktopHeader,
        'component-items': ItemsList,
    },
    methods: {},
    created: function(){}
}


// WEBPACK FOOTER //
// ./src/pages/ManageItems/desktop/script.js